
















import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import GoogleMap from '@/components/GoogleMap.vue';
import EventBus from '@/services/eventbus.service';
import {
  Getter,
  Mutation,
} from 'vuex-class';
import Map from '@/components/Map.vue';

@Component({
  components: {
    Map,
    GoogleMap,
  },
})

export default class MapWidget extends Vue {
  @Getter private hasPermission!: any;
  @Prop() private data!: any;
  @Prop() private container!: any;
  private siteData: any[] = [];
  private height: number = 0;
  private width: number = 0;
  private searchString: string = '';
  private open = false;
  private loading = true;

  @Getter private widgetFilters!: string[];

  @Watch('container')
  private onContainerResize() {
    if (this.container && this.container.$el) {
      this.height = (this.container.$el as HTMLElement).offsetHeight - 90;
      this.width = (this.container.$el as HTMLElement).offsetWidth - 32;

    }
  }

  private clearSearch() {
    this.searchString = '';
    this.initFilters();
  }

  private doSearch() {
    if (this.searchString) {
      const lowercase = this.searchString.toLowerCase();

      const pins = this.siteData.filter((d: any) => d.siteName.toLowerCase().includes(lowercase));
      if (pins.length) {
        Vue.set(this, 'siteData', pins);
      } else {
        this.initFilters();
      }
    }
  }
  private mounted() {
    if (!this.open && this.$route.path.includes('map')) {
      // this.$router.replace('/dashboard')
      this.open = true;
    }
    EventBus.$on('filterByProject', this.filterBy);
    EventBus.$on('clearFilter', this.clearFilter);

    this.initFilters();
    this.onContainerResize();
  }

  private beforeDestroy() {
    EventBus.$off('filterByProject', this.filterBy);
    EventBus.$off('clearFilter', this.clearFilter);
  }

  private initFilters() {
    this.siteData = [...this.data.payload.devices];
    let filters = this.widgetFilters;
    filters = filters.filter((f: string) => f !== null);

    if (filters && filters.length) {
      const pins = this.siteData.filter((d: any) => filters.find((filter: string) => d.projectName === filter));

      Vue.set(this, 'siteData', pins);
    }
  }

  private filterBy(filter: string) {
    this.siteData = this.siteData.filter((d: any) => d.projectName === filter);
  }

  private clearFilter() {
    this.siteData = [...this.data.payload.devices];
  }
}
